<template>
  <banner
    v-if="shouldShowBanner"
    color-scheme="alert"
    :banner-message="bannerMessage"
    :action-button-label="actionButtonMessage"
    has-action-button
    @click="routeToBilling"
  />
</template>

<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import { mapGetters } from 'vuex';
import adminMixin from 'dashboard/mixins/isAdmin';
import accountMixin from 'dashboard/mixins/account';

const RENEWAL_NEEDED_STATUSES = ['past_due', 'expired', 'cancelled', 'pending_payment'];

export default {
  components: { Banner },
  mixins: [adminMixin, accountMixin],
  computed: {
    ...mapGetters({
      subscription: 'accounts/getSubscriptionInfo',
    }),
    bannerMessage() {
      if (this.subscription.sub_status === 'expired') {
        return this.$t('GENERAL_SETTINGS.SUBSCRIPTION_EXPIRED');
      }
      if (this.subscription.sub_status === 'cancelled') {
        return this.$t('GENERAL_SETTINGS.SUBSCRIPTION_CANCELLED');
      }
      return this.$t('GENERAL_SETTINGS.PAYMENT_PENDING');
    },
    actionButtonMessage() {
      return this.$t('GENERAL_SETTINGS.RENEW_NOW');
    },
    shouldShowBanner() {
      if (!this.isAdmin) {
        return false;
      }
      return RENEWAL_NEEDED_STATUSES.includes(this.subscription.sub_status);
    },
  },
  methods: {
    routeToBilling() {
      this.$router.push({
        name: 'billing_settings_index',
        params: { accountId: this.accountId },
      });
    },
  },
};
</script>
